module.exports = __webpack_public_path__ + "static/img/podyplomowe.42af34b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/podyplomowe.jpg
// module id = 56Kz
// module chunks = 1